import { useQuery, useMutation, useQueryClient } from 'react-query';
import { apiClient } from '../services/apiClient';
import { DiagnosisRelevantVariablesReadDTO, DiagnosisRelevantVariablesCreateDTO } from '../generated/api-client';

export const useDiagnosisRelevantVariables = () => {
  return useQuery<DiagnosisRelevantVariablesReadDTO[]>('diagnosisRelevantVariables', () => apiClient.list_items_diagnosis_relevant_variables__get());
};

export const useDiagnosisRelevantVariablesById = (id: string) => {
  return useQuery<DiagnosisRelevantVariablesReadDTO>(
    ['diagnosisRelevantVariables', id],
    () => apiClient.get_item_diagnosis_relevant_variables__item_id__get(id),
    {
      enabled: !!id,
    }
  );
};

export const useDiagnosisRelevantVariablesByDiagnosisId = (diagnosisId: string) => {
  return useQuery<DiagnosisRelevantVariablesReadDTO[]>(
    `diagnosis-relevant-variables-${diagnosisId}`,
    () => apiClient.search_by_diagnosis_id_diagnosis_relevant_variables_search_by_diagnosis_id__diagnosis_id__get(diagnosisId),
    {
      enabled: !!diagnosisId,
    }
  );
};

export const useCreateDiagnosisRelevantVariables = () => {
  const queryClient = useQueryClient();

  return useMutation<DiagnosisRelevantVariablesReadDTO, Error, DiagnosisRelevantVariablesCreateDTO>(
    (data) => apiClient.create_item_diagnosis_relevant_variables__post(data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('diagnosisRelevantVariables');
        queryClient.invalidateQueries(['diagnosisRelevantVariables', 'byDiagnosisId']);
        // Invalida tutte le query che iniziano con 'diagnosis-relevant-variables-'
        queryClient.invalidateQueries({
          predicate: query => {
            const key = query.queryKey;
            if (typeof key === 'string') {
              return key.startsWith('diagnosis-relevant-variables-');
            }
            if (Array.isArray(key) && key.length > 0) {
              const firstKey = key[0];
              return typeof firstKey === 'string' && firstKey.startsWith('diagnosis-relevant-variables-');
            }
            return false;
          },
        });
      },
    }
  );
};

export const useUpdateDiagnosisRelevantVariables = () => {
  const queryClient = useQueryClient();

  return useMutation<DiagnosisRelevantVariablesReadDTO, Error, { id: string; data: DiagnosisRelevantVariablesCreateDTO }>(
    ({ id, data }) => apiClient.update_item_diagnosis_relevant_variables__item_id__put(id, data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('diagnosisRelevantVariables');
        queryClient.invalidateQueries(['diagnosisRelevantVariables', 'byDiagnosisId']);
        // Invalida tutte le query che iniziano con 'diagnosis-relevant-variables-'
        queryClient.invalidateQueries({
          predicate: query => {
            const key = query.queryKey;
            if (typeof key === 'string') {
              return key.startsWith('diagnosis-relevant-variables-');
            }
            if (Array.isArray(key) && key.length > 0) {
              const firstKey = key[0];
              return typeof firstKey === 'string' && firstKey.startsWith('diagnosis-relevant-variables-');
            }
            return false;
          },
        });
      },
    }
  );
};

export const useDeleteDiagnosisRelevantVariables = () => {
  const queryClient = useQueryClient();

  return useMutation<any, Error, string>(
    (id) => apiClient.delete_item_diagnosis_relevant_variables__item_id__delete(id),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('diagnosisRelevantVariables');
        queryClient.invalidateQueries(['diagnosisRelevantVariables', 'byDiagnosisId']);
        // Invalida tutte le query che iniziano con 'diagnosis-relevant-variables-'
        queryClient.invalidateQueries({
          predicate: query => {
            const key = query.queryKey;
            if (typeof key === 'string') {
              return key.startsWith('diagnosis-relevant-variables-');
            }
            if (Array.isArray(key) && key.length > 0) {
              const firstKey = key[0];
              return typeof firstKey === 'string' && firstKey.startsWith('diagnosis-relevant-variables-');
            }
            return false;
          },
        });
      },
    }
  );
};

